import React from "react";
import { CustomIconButton, icon } from "../../../../../../common/components";
import styles from "./SideDrawerOption.module.css";
import { translate } from "../../../../../../common/providers";

const SideDrawerOption = ({ open, onOpen }) => {
	const handleOpen = () => {
		onOpen();
	};
	return (
		<div className={styles.sideDrawerOption}>
			{open && <div className={styles.title}>{translate("smart-review.header.toc-list")}</div>}
			<CustomIconButton
				icon={(open && icon.faAngleDoubleLeft) || icon.faAngleDoubleRight}
				variant="outlined"
				onClick={handleOpen}
			/>
		</div>
	);
};

export default SideDrawerOption;
